import { createFileRoute } from '@tanstack/react-router';

import { RolesPage } from '@/features/members/pages/RolesPage';

export const Route = createFileRoute('/_authenticated/roles/')({
  component: RolesPage,
});
